<template>
  <div id="app">
    <section id="contentCnt">
      <router-view/>
    </section>
    <Footer/>
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue';

export default {
  name: 'home',
  components: { Footer },
  data() {
    return {
    };
  },
  methods: {},
  mounted() {},
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Hind+Siliguri:wght@300;400;500;600;700&display=swap');
body{
  margin: 0;
  padding: 0;
  font-family: 'Hind Siliguri', sans-serif;
  color: #444;
  input, textarea, select, button{
    font-family: 'Hind Siliguri', sans-serif;
  }
  line-height: 1.3;
  padding-top: 64px;
  &.hideFooter{
    padding-top: 0;
    header{ display: none; }
    footer{ display: none; }
  }
  &.hideFooterOnly{
    footer{ display: none; }
  }
  @media (max-width: 760px) {
    padding-top: 54px;
  }
}
#contentCnt{
  min-height: calc(100vh - 64px);
  @media (max-width: 760px) {
    min-height: calc(100vh - 54px);
  }
}
.cnt{
  max-width: 1400px;
  margin: 0 auto;
  @media (max-width: 1480px) {
    margin: 0 20px;
  }
}
.clear{
  clear: both;
}
a{
  color: #002f5f;
  text-decoration: none;
  &:hover{
    color: #004c9a;
  }
}

h4{
  font-weight: 600;
}

.modalContent{
  transition: all .2s ease;
}
.fade-enter-active,
.fade-leave-active {
  transition: all .2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  .modalContent{
    transform: scale(.9);
  }
}

.fieldGroup{
  margin-bottom: 16px;
  .field{
    border: #ccc 1px solid;
    border-radius: 5px;
    padding: 12px 14px 10px;
    font-size: 17px;
    background-color: #fff;
    outline: 0;
    box-shadow: none;
    width: 100%;
    box-sizing: border-box;
    line-height: 1.4;
    &:hover{
      border-color: #fff;
      box-shadow: 0 0 0 2px #999;
    }
    &:focus{
      border-color: #fff;
      box-shadow: 0 0 0 2px #002f5f;
    }
  }
  .fieldCnt{
    position: relative;
    &.hasError{
      .field{
        border-color: #fff;
        box-shadow: 0 0 0 2px red;
      }
      .fieldError{
        display: block;
      }
      .hint{
        display: none;
      }
    }
    &.hasPrefix{
      .field{
        padding-left: 60px;
      }
      .prefix{
        position: absolute;
        left: 1px; top: 1px; bottom: 1px;
        background-color: #eee;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 5px 0 0 5px;
        padding: 0 10px;
        border-right: #e5e5e5 1px solid;
      }
    }
    .showPwd{
      width: 30px; height: 30px;
      position: absolute;
      right: 8px; top: 50%;
      margin-top: -15px;
      border-radius: 50%;
      background-image: url(assets/eye-closed.png);
      background-size: 20px auto;
      background-position: center;
      background-repeat: no-repeat;
      cursor: pointer;
      transition: all .3s ease;
      opacity: .8;
      &:hover{
        background-color: #eee;
        opacity: 1;
      }
      &.show{
        background-image: url(assets/eye.png);
      }
    }
  }
  .fieldError{
    color: red;
    font-size: 12px;
    margin: 6px 0 0 7px;
  }
  .hint{
    color: #767676;
    font-size: 12px;
    margin: 0;
    padding: 6px 0 0 7px;
  }
  &.hasError{
    .field{
      border-color: #fff;
      box-shadow: 0 0 0 2px red;
    }
    .hint{
      display: none;
    }
  }
}

.btn{
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  font-weight: bold;
  font-size: 17px;
  outline: 0 !important;
  cursor: pointer;
  transition: all .2s ease;
  background-size: 36px auto;
  background-position: center;
  background-repeat: no-repeat;
  &.btnLg{
    font-size: 20px;
    padding: 12px 24px;
  }
  &.btnPrimary{
    background-color: #002f5f;
    color: #fff;
    font-weight: 600;
    &:hover{
      background-color: #004c9a;
      box-shadow: 2px 2px 4px rgba(0,0,0,.1);
    }
  }
  &.loading{
    background-image: url(assets/loading.svg);
    background-color: #ccc !important;
    color: #999 !important;
    box-shadow: none !important;
    cursor: default;
    span{
      // display: none;
      visibility: hidden;
    }
  }
}
.btnNegative{
  background-color: #e83838;
  color: #fff;
}
.btnNegative:hover{
  background-color: red;
  box-shadow: 2px 2px 4px rgba(0,0,0,.1);
}
.btnSecondary{
  background: none;
  color: #002f5f;
  font-weight: 600;
}
.btnSecondary:hover{
  background-color: #e5e5e5;
  box-shadow: 2px 2px 2px rgba(0,0,0,.1);
}
.btnBlue{
  background-color: #3576ca;
  &:hover{
    background-color: #1f64bd;
    box-shadow: 2px 2px 4px rgba(0,0,0,.1);
  }
}
.btnGreen{
  background-color: #97c253;
  &:hover{
    background-color: #75a22d;
    box-shadow: 2px 2px 4px rgba(0,0,0,.1);
  }
}
.clear{
  clear: both;
}

.viewer-backdrop {
  background-color: rgba(0, 0, 0, .76);
  backdrop-filter: blur(30px);
}
.viewer-list > li{
  // margin-top: 10px;
  // height: 30px;
  // border-radius: 50%;
}
</style>
